import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { useChatStore } from "../../stores/ChatStore";
import { toAbsoluteUrl } from "../../_metronic/helpers";
import { focusChatInput } from "../../functions/chat";
import { ContactChatProps } from "../../interfaces/Chat/ContactChat";
import { useVirtualizer } from "@tanstack/react-virtual";
import { ChatMessage, ListChatRoom } from "../../interfaces/Chat/Chat";

const ChatInititate = () => {
    const intl = useIntl()
    const {
        setMenuActive, setMessage, setIsOpenDetailContact, setMessages, setShowChat,
        setPhoneNumber, setMode, listChatMessages, setListChatRooms, setMessageNotifications,
        selectedChatPhone, chatContacts
    } = useChatStore()
    const parentRef = useRef<HTMLDivElement>(null);
    const [dataChatContacts, setDataChatContacts] = useState<ContactChatProps[]>([])
    const [search, setSearch] = useState('')

    const virtualizer = useVirtualizer({
        count: dataChatContacts.length,
        getScrollElement: () => parentRef.current,
        estimateSize: (index) => 250,
        overscan: 5, // Tambahkan elemen buffer di atas dan bawah
        enabled: true,
    });

    const items = virtualizer.getVirtualItems();

    const debounce = <F extends (...args: any[]) => void>(func: F, delay: number) => {
        let timeoutId: NodeJS.Timeout;
        return function (this: any, ...args: Parameters<F>) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };
    const debouncedSetSearch = debounce(setSearch, 500);

    const handleContactClick = async (name: string, phone: string) => {
        const { messageNotifications } = useChatStore.getState();

        setMenuActive("chat")
        setMode('normal')
        setMessage('')
        setIsOpenDetailContact(false)
        if (listChatMessages[`${phone}-${selectedChatPhone[0].phone}`] && listChatMessages[`${phone}-${selectedChatPhone[0].phone}`].length > 0) {
            setMessages(() => listChatMessages[`${phone}-${selectedChatPhone[0].phone}`])
        } else {
            setMessages(() => [])

            let newChatRooms: ListChatRoom = {
                [`${phone}-${selectedChatPhone[0].phone}`]: {
                    as: selectedChatPhone[0].phone,
                    roomPhone: phone,
                    roomName: name ? name : phone,
                    chat: {} as ChatMessage,
                    labels: [],
                    merchants: [],
                    pipelines: [],
                    isMerchantOnly: false,
                    color: selectedChatPhone.find((item) => item.phone === selectedChatPhone[0].phone)?.color!,
                    connected: true,
                    selected: false,
                    loading: false,
                }
            }

            setListChatRooms((prevListChatRooms) => ({
                ...prevListChatRooms,
                ...newChatRooms
            }));
        }


        setShowChat(true)
        setPhoneNumber(`${phone}-${selectedChatPhone[0].phone}`)
        const { [`${phone}-${selectedChatPhone[0].phone}`]: removedItem, ...rest } = messageNotifications;

        setMessageNotifications(() => rest);
        focusChatInput()
    }

    useEffect(() => {
        setDataChatContacts(chatContacts)
    }, [chatContacts])

    useEffect(() => {
        if (search === '') setDataChatContacts(chatContacts)
        else {
            let value = search.toLowerCase();
            if (value.length >= 2) {
                if (value.substring(0, 2) === '08') {
                    value = '628' + value.substring(2);
                }
            }

            const filtered = chatContacts.filter(
                (item) =>
                    item.name.toLowerCase().includes(value) ||
                    item.id.replace('@s.whatsapp.net', "").toLowerCase().includes(value)
            );

            setDataChatContacts(filtered);
        }
    }, [search])

    return (
        <div className='card card-flush w-100 p-3' style={{ maxHeight: "calc(100vh - 1rem)", height: "calc(100vh - 1rem)" }}>
            <div className="d-flex align-items-center my-1 mb-3 justify-content-between">
                <div className="d-flex align-items-center gap-5">
                    <i className="p-3 cursor-pointer fas fa-solid fa-arrow-left fs-3" onClick={() => setMenuActive("chat")}></i>
                    <h1 className="mb-0 text-dark fw-bolder fs-1">Chat Baru</h1>
                </div>
            </div>
            <form className='w-100 position-relative mb-5' autoComplete='off'>
                <span className="svg-icon svg-icon-1 position-absolute ms-6 mt-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black" />
                        <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black" />
                    </svg>
                </span>
                <input
                    type="search"
                    className="form-control form-control-solid ps-15"
                    placeholder={intl.formatMessage({ id: 'MASTERS.DATATABLE.SEARCH.PLACEHOLDER' })}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') e.preventDefault()
                    }}
                    style={{ borderRadius: "50px" }}
                    onChange={(e) => debouncedSetSearch(e.target.value)}
                />
            </form>
            <div ref={parentRef} style={{ height: "100%", overflowY: "auto", position: "relative", contain: 'strict' }} >
                <div style={{ height: virtualizer.getTotalSize(), position: "relative", width: '100%' }}>
                    {items.map((virtualItem) => {
                        const data = dataChatContacts[virtualItem.index];

                        return (
                            <div key={virtualItem.key.toString()} data-index={virtualItem.index} ref={virtualizer.measureElement} style={{ position: "absolute", top: 0, left: 0, width: "100%", transform: `translateY(${virtualItem.start}px)` }} onClick={() => handleContactClick(data.name, data.id.replace("@s.whatsapp.net", ""))}>
                                <div key={virtualItem.index} className="d-flex align-items-center p-3 rounded-2 bg-hover-light" onClick={() => handleContactClick(data.name, data.id.replace("@s.whatsapp.net", ""))}>
                                    <div className='symbol symbol-45px symbol-circle'>
                                        <span className='symbol-label bg-light-danger text-danger fs-6 fw-bolder'>
                                            <img src={toAbsoluteUrl('/media/logos/logo-wooblazz.png')} className='symbol symbol-45px symbol-circle img-fluid' style={{ padding: "10px" }} alt='profile' />
                                        </span>
                                    </div>
                                    <div className="d-flex justify-content-between w-100">
                                        <div className="ms-5">
                                            <span className="text-gray-800 fw-bolder fs-6">{data.name}</span>
                                            <span className="text-gray-400 fw-bold fs-7 d-block text-start ps-0">{data.id.replace("@s.whatsapp.net", "")}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    )
}

export { ChatInititate }